import styled from 'styled-components';

import ArrowLeftDetailsOneIcon from '../../../../../../Icons/ArrowLeftDetailsOneIcon';
import ArrowRightDetailsOneIcon from '../../../../../../Icons/ArrowRightDetailsOneIcon';
import Image from '@stencil/image';

export const MainGalleryOuterWrapDiv = styled.div(
  props => `
  position: relative;
  z-index: ${props.theme.misc.zIndex.xsmall};
  margin-bottom: 1.3rem;
  overflow:hidden;
`,
);

export const HotelMainGalleryImage = styled(Image)(
  props => `
  display: flex;
  width: 100%;
  height: 28rem;
  object-fit: cover;
  flex: 0 0 100%;
  min-width: 0;
`,
);

export const LeftArrowOuterWrapper = styled.button(
  props => `

  color: ${props.theme.colors.goWhite.base};
  top: 15.5rem;
  left: 2rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.goWhite.base};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  transform: translateY(-50%);
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  color: ${props.theme.colors.goBrandBlue.base};
  position: absolute;
  z-index: ${props.theme.misc.zIndex.large};
  border: none;
  &:focus {
    outline: none;
  }
`,
);

export const RightArrowOuterWrapper = styled.button(
  props => `
  color: ${props.theme.colors.goWhite.base};
  top: 15.5rem;
  right: 2rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.goWhite.base};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  transform: translateY(-50%);
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  color: ${props.theme.colors.goBrandBlue.base};
  position: absolute;
  z-index: ${props.theme.misc.zIndex.large};
  border: none;
  &:focus {
    outline: none;
  }
`,
);

export const LeftArrow = styled(ArrowLeftDetailsOneIcon)(
  props => `

  width:1.5rem;
  height:1.5rem;

  `,
);

export const RightArrow = styled(ArrowRightDetailsOneIcon)(
  props => `

  width:1.5rem;
  height:1.5rem;

  `,
);

export const CarouselImagesWrapper = styled.div(
  props => `
  overflow: auto;
  display: flex;
  flex-direction: row;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
   border-radius: 0.4rem;
  -ms-overflow-style: none;
`,
);
